// src/components/Dashboard/DashboardComponents/EngagementCredibilityPanel.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';
import InfoTooltip from '../ui/InfoTooltip';

const EngagementCredibilityPanel = ({ userEngagement }) => {
  const { t } = useTranslation();
  if (!userEngagement) return null;

  return (
    <div className="bg-white border border-gray-200 dark:bg-slate-900/60 dark:border-slate-800/60 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-4">
        <Award className="w-5 h-5 text-amber-400" />
        <h2 className="text-base font-bold text-gray-800 dark:text-slate-200">{t('credibility.engagementPanel.title')}</h2>
      </div>

      <div className="space-y-3">
        {/* Score block */}
        <div className="flex items-center justify-between pb-3 border-b border-gray-200 dark:border-slate-800/50">
          <div className="flex items-center gap-1">
            <span className="text-sm text-gray-500 dark:text-slate-400">{t('credibility.engagementPanel.scoreLabel')}</span>
            <InfoTooltip text={t('credibility.engagementPanel.scoreTooltip')} />
          </div>
          <div className="text-right">
            {/* text-blue-400 (a light/medium blue tuned for dark backgrounds)
                on this card's light-mode bg-white gave a 2.54:1 contrast
                ratio, well under WCAG AA's 3:1 minimum for large bold text --
                found by the pass-28 accessibility sweep. */}
            <span className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {userEngagement.credibility_score.toFixed(1)}
            </span>
          </div>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-3 gap-2 sm:gap-3 pt-2 border-t border-gray-200 dark:border-slate-800/50">
          <div className="text-center min-w-0">
            <div className="text-lg sm:text-xl font-bold text-gray-800 dark:text-slate-100">
              {userEngagement.posts_7d}
            </div>
            <div className="text-[11px] sm:text-xs text-gray-500 dark:text-slate-500 mt-0.5">{t('credibility.engagementPanel.posts7d')}</div>
          </div>
          <div className="text-center min-w-0">
            <div className="text-lg sm:text-xl font-bold text-gray-800 dark:text-slate-100">
              {userEngagement.groups_active}
            </div>
            <div className="text-[11px] sm:text-xs text-gray-500 dark:text-slate-500 mt-0.5">{t('credibility.engagementPanel.groupsActive')}</div>
          </div>
          <div className="text-center min-w-0">
            <div className="text-lg sm:text-xl font-bold text-gray-800 dark:text-slate-100">
              {userEngagement.watchlist_size}
            </div>
            <div className="text-[11px] sm:text-xs text-gray-500 dark:text-slate-500 mt-0.5">{t('credibility.engagementPanel.watchlistSize')}</div>
          </div>
        </div>

        {/* Followers */}
        <div className="flex items-center justify-between text-xs pt-1">
          <span className="text-gray-500 dark:text-slate-500">
            {t('credibility.engagementPanel.followers', { count: userEngagement.followers })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EngagementCredibilityPanel;
